import { sva } from "@agapi/ui/panda/css";

export const languagePickerMobileStyles = sva({
  slots: [
    "container",
    "sectionContainer",
    "buttonContainer",
    "heading",
    "button",
  ],
  base: {
    container: {
      display: "flex",
      flexDirection: "column",
      gap: "4",
      padding: "4",
      pb: "5",
      px: "app",
      width: "100%"
    },
    sectionContainer: {
      display: "flex",
      flexDirection: "column",
      gap: "3",
      width: "100%"
    },
    buttonContainer: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      gap: "2",
      py: "3",
      width: "100%"
    },
    heading: {
      fontSize: "lg",
      mb: "2"
    },
    button: {
      justifyContent: "start",
      minWidth: "110px"
    }
  },
});